import { analytics } from 'utils';
import { AkinatorCompletion } from 'types/suggestions';

export const getAkinatorCompletionAnalyticsText = (elementIndex: number, completion: AkinatorCompletion) =>
  `Акинатор/${elementIndex}-${completion.name}`;

export const sendAkinatorAnalyticsEvent = (elementText: string, searchQuery: string) => {
  analytics.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'header', // блок, в котором расположен элемент
    elementName: 'searchAkinator', // условное обозначение
    elementText,
    eventVariant: searchQuery,
  });
};

export const sendAkinatorCompletionAnalyticsEvent = (
  elementIndex: number,
  completion: AkinatorCompletion,
  searchQuery = '',
) => sendAkinatorAnalyticsEvent(getAkinatorCompletionAnalyticsText(elementIndex, completion), searchQuery);

export const useAkinatorAnalyticsEvent = (elementText: string, searchQuery: string) => () => {
  sendAkinatorAnalyticsEvent(elementText, searchQuery);
};
